export default __webpack_public_path__ + "static/open_metadata-bc22bb64764ceed46a254cf9c67194f0.png";